import 'ui-theme/plugins/scrollo/js/scrollo';
import {keyCodes} from 'ui-core/utility/js/utils';
(function () {
    var $body = $('body');
    UX.scrollo.control = function () {
        $(window).on('hashchange load', UX.scrollo.adjustAnchor);
        /**
         * checks for any <a> tag that has the hash-tag prefix and execute the adjustAnchor function
         * the .content a[href^="#"] was added to support the publication content <a> tags
         */
        $body.on(
            'click',
            'a.table-fn[href^="#"], a.ref.fn[href^="#"], .scroll-to-target a[href^="#"], .content a[href^="#"]:not([data-toggle="tab"])',
            function (e) {
                if (window.location.hash === $(this).attr('href')) {
                    UX.scrollo.adjustAnchor(e);
                }
            }
        );
        $body.on('click keydown', 'a[href^="#"].sr-only-focusable', function (e) {
            // pass click and ENTER to action
            if (e.keyCode && e.keyCode !== keyCodes.ENTER) {
                return;
            }
            if (window.location.hash === $(this).attr('href')) {
                UX.scrollo.adjustAnchor(e);
            }
        });
        $body.on('click', '.w-slide__back', function () {
            if ($('[data-scroll-back-to]').length) {
                $(document).scrollTop($('[data-scroll-back-to]').data('scroll-back-to'));
                $('[data-scroll-back-to]').removeAttr('data-scroll-back-to');
            }
        });
    };
})();
